import React from "react";

import {
  useDispatch,
  useSelector,
} from "react-redux";

import {
  useTranslation,
} from "react-i18next";

import {
  motion,
  AnimatePresence,
} from "framer-motion";

import {
  FiGrid,
  FiSquare,
} from "react-icons/fi";

import {
  toggleMobileMealColumns,
} from "../../redux/actions/layout";


function MobileMealsViewToggle() {
  const {
    t,
  } = useTranslation();

  const dispatch =
    useDispatch();


  const mobileMealColumns =
    useSelector(
      (state) =>
        state.Layout
          ?.mobileMealColumns ||
        "two"
    );


  const isTwoColumns =
    mobileMealColumns ===
    "two";


  return (
    <motion.button
      type="button"

      whileTap={{
        scale: 0.92,
      }}

      onClick={() =>
        dispatch(
          toggleMobileMealColumns()
        )
      }

      aria-label={
        isTwoColumns
          ? t(
              "switch to one column"
            )
          : t(
              "switch to two columns"
            )
      }

      title={
        isTwoColumns
          ? t(
              "two columns"
            )
          : t(
              "one column"
            )
      }

      className="
        md:hidden

        relative

        flex

        w-[48px]
        h-[48px]

        shrink-0

        items-center
        justify-center

        rounded-xl

        border
        border-color-1/20
        dark:border-white/10

        bg-color-1/5
        dark:bg-white/5

        text-color-1

        shadow-[0_5px_18px_rgba(68,37,20,0.06)]

        transition-all
        duration-300

        hover:border-color-1
        hover:bg-color-1
        hover:text-white
      "
    >

      <AnimatePresence
        mode="wait"
        initial={false}
      >

        <motion.span
          key={
            mobileMealColumns
          }

          initial={{
            opacity: 0,
            scale: 0.7,
            rotate: -15,
          }}

          animate={{
            opacity: 1,
            scale: 1,
            rotate: 0,
          }}

          exit={{
            opacity: 0,
            scale: 0.7,
            rotate: 15,
          }}

          transition={{
            duration: 0.18,
          }}
        >
          {isTwoColumns ? (
            <FiGrid
              size={20}
            />
          ) : (
            <FiSquare
              size={20}
            />
          )}
        </motion.span>

      </AnimatePresence>


      {/* 1 / 2 indicator */}

      <span
        className="
          absolute

          -top-1
          -end-1

          flex

          min-w-[18px]
          h-[18px]

          items-center
          justify-center

          rounded-full

          bg-color-1

          px-1

          text-[9px]
          font-bold
          text-white

          ring-2
          ring-back-primery
          dark:ring-back-darksecondary
        "
      >
        {isTwoColumns
          ? "2"
          : "1"}
      </span>

    </motion.button>
  );
}


export default MobileMealsViewToggle;